import React from "react";
import { Box, Typography, Container, Grid, Divider } from "@mui/material";

const About = () => {
  return (
    <Box sx={{ pt: 6, pb: 10 }}>
      <Container maxWidth="lg">
        
        {/* HEADING */}
        <Typography
          variant="h3"
          fontWeight={800}
          gutterBottom
          sx={{ textAlign: "center", mb: 3 }}
        >
          About MakeMyShows
        </Typography>

        <Typography
          variant="subtitle1"
          sx={{
            textAlign: "center",
            color: "text.secondary",
            maxWidth: "700px",
            mx: "auto",
            lineHeight: 1.6,
          }}
        >
          Bringing seamless artist discovery and booking experiences to everyone.
        </Typography>

        {/* MAIN CONTENT */}
        <Typography
          variant="h5"
          fontWeight="bold"
          sx={{ mt: 6, mb: 2 }}
        >
          Our Mission & Vision
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ lineHeight: 1.9 }}
        >
          Founded in 2025, MakeMyShows is a simplified online platform designed
          to help people easily book verified live artists for events — whether
          it’s a birthday celebration, wedding, corporate event, private party, 
          or a house celebration. Our platform ensures a seamless booking 
          experience, transparent pricing, and trusted performers.
          <br /><br />
          Backed by a passionate team with industry experience, we aim to bridge
          the gap between event organizers and performers — making live 
          entertainment accessible, reliable, and unforgettable.
        </Typography>

        <Divider sx={{ my: 6 }} />

        {/* CONTACT SECTION */}
        <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>
          Contact Us
        </Typography>

        <Grid container spacing={4} sx={{ lineHeight: 1.9 }}>
          <Grid item xs={12} md={6}>
            <Typography variant="h6" fontWeight="bold">
              Sales
            </Typography>
            <Typography variant="body1">📞 +91-1140849916</Typography>

            <Typography variant="h6" fontWeight="bold" sx={{ mt: 3 }}>
              Customer Support
            </Typography>
            <Typography variant="body1">📞 +91-9528294837</Typography>

            <Typography variant="h6" fontWeight="bold" sx={{ mt: 3 }}>
              Email
            </Typography>
            <Typography variant="body1">
              📧 support@makemyshows.in
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="h6" fontWeight="bold">
              Address
            </Typography>
            <Typography variant="body1">
              Plot No. 2A, First Floor, KH No. 294,
              Kehar Singh Estate, Saidulajab, Saket,
              New Delhi, Delhi 110030
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default About;
